import { useMemo } from 'react';

import { type Network } from '@hivebrite/frontoffice-default-app-contexts';

import { useCurrentNetwork } from 'hb-react/shared/contexts';
import { useDefaultAppContextsCamelCase } from 'hb-react/shared/hooks/useDefaultAppContextsCamelCase';

/**
 * Hook that provides a simplified currentNetwork object compatible with
 * the front monorepo DefaultAppContexts from @hivebrite/frontoffice-default-app-contexts
 */
export const useFrontMonorepoCurrentNetwork = () => {
  const { currentNetwork: currentNetworkSnakeCase } = useCurrentNetwork();
  const {
    currentNetwork,
    currentUser,
    currentSession,
    currentAdmin,
    currentUrl,
  } = useDefaultAppContextsCamelCase();

  const simplifiedCurrentNetwork: Network | null = useMemo(() => {
    if (!currentNetwork) {
      return null;
    }

    // Extract only the properties needed by the front monorepo DefaultAppContexts
    return {
      id: currentNetwork.id,
      title: currentNetwork.title,
      pageTitle: currentNetwork.pageTitle,
      identifier: currentNetwork.identifier,
      adminNotificationEmails: currentNetwork.adminNotificationEmails,
      theming: currentNetworkSnakeCase.theming,
    };
  }, [currentNetwork, currentNetworkSnakeCase.theming]);

  return {
    currentNetwork: simplifiedCurrentNetwork,
    currentUser,
    currentSession,
    currentAdmin,
    currentUrl,
  };
};
